export default {
  SUCCESS: 0,
  NEED_LOGON: 40309,
  EXPIRE_LOGIN: 40308,
  NO_AUDIT: 40305,
};
